<template>
  <div id="contenedor-listado-seguimiento-detalle-observacion">
    <template
      v-if="$apollo.queries.auditoriaInformeObservacionDetalleSeguimientos.loading">
      <v-skeleton-loader
        type="table-heading, table-thead, table-tbody">
      </v-skeleton-loader>
    </template>
    <template
      v-else>
      <v-data-table
        :headers="headers"
        :items="auditoriaInformeObservacionDetalleSeguimientos"
        hide-default-footer>
        <template v-slot:[`item.documento`]="{ item }">
          <v-btn icon @click="descargarArchivo(item)">
            <v-icon>
              mdi-download
            </v-icon>
          </v-btn>
        </template>
        <template v-slot:[`item.acciones`]="{ item }">
          <v-btn
            v-if="idRespuestaDetalle"
            @click="integrarSeguimientoRespuestaDetalleDocumento(item)">
            Integrar
          </v-btn>
          <v-btn
            v-show="!soloLectura"
            icon
            @click="eliminarSeguimiento(item)">
            <v-icon>
              mdi-delete
            </v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </template>
  </div>
</template>

<script>
import LISTADO_SEGUIMIENTO_DETALLE_OBSERVACION from '@/graphql/querys/administracion/auditorias/auditoriaInformeObservacionDetalleSeguimientos.gql';
import BORRAR_SEGUIMIENTO from '@/graphql/querys/administracion/auditorias/removerAuditoriaInformeObservacionDetalleSeguimiento.gql';
import AGREGAR_AUDITORIA_INFORME_RESPUESTA_DETALLE_DOCUMENTO from '@/graphql/mutations/administracion/auditorias/respuestas/detalles/documentos/agregarAuditoriaInformeRespuestaDetalleDocumento.gql';
import mixDescargarArchivos from '@/helpers/mixDescargarArchivo';

export default {
  name: 'ListadoSeguimientoDetalleObservacion',
  mixins: [mixDescargarArchivos],
  props: {
    idDetalle: {
      type: String,
      required: true,
    },
    idRespuestaDetalle: {
      type: String,
      required: false,
    },
    soloLectura: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      documento: {
        idAuditoriaInformeRespuestaDetalle: null,
        idAuditoriaInformeRespuestaDetalleSeguimiento: null,
        nombre: '',
        fileData: null,
      },
      headers: [
        { text: 'Acción/Documento', value: 'accion', sortable: false },
        { text: 'Comentarios', value: 'comentarios', sortable: false },
        {
          text: 'Documento', align: 'center', value: 'documento', sortable: false,
        },
        {
          text: '', align: 'right', value: 'acciones', sortable: false,
        },
      ],
    };
  },
  apollo: {
    auditoriaInformeObservacionDetalleSeguimientos: {
      query: LISTADO_SEGUIMIENTO_DETALLE_OBSERVACION,
      variables() {
        return {
          idAuditoriaInformeObservacionDetalle: this.idDetalle,
          tipo: 1, // Respuestas
        };
      },
    },
  },
  methods: {
    async integrarSeguimientoRespuestaDetalleDocumento(seguimiento) {
      this.documento.idAuditoriaInformeRespuestaDetalle = this.idRespuestaDetalle;
      this.documento.idAuditoriaInformeRespuestaDetalleSeguimiento = seguimiento.id;
      this.documento.nombre = 'nombre';
      this.documento.fileData = seguimiento.fileData;

      this.mixEsCargando();

      await this.$apollo
        .mutate({
          mutation: AGREGAR_AUDITORIA_INFORME_RESPUESTA_DETALLE_DOCUMENTO,
          variables: {
            documento: this.documento,
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });
      this.mixEsCargando();

      await this.$apollo.queries.auditoriaInformeRespuestaDetalleDocumentos.refetch({
        idAuditoriaInformeRespuestaDetalle: this.idRespuestaDetalle,
      });
    },
    async eliminarSeguimiento(seguimiento) {
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: BORRAR_SEGUIMIENTO,
        variables: {
          id: seguimiento.id,
        },
      }).then(async () => {
        await this.$apollo.queries.auditoriaInformeObservacionDetalleSeguimientos.refetch({
          idAuditoriaInformeObservacionDetalle: this.idDetalle,
        });
        this.mixMensajeSuccess();
        this.$emit('success');
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.mixEsCargando();
    },
    async descargarArchivo(seguimiento) {
      let fileData = null;

      if (seguimiento.fileData) {
        fileData = JSON.parse(seguimiento.fileData);
        fileData.publicKey = fileData.public_key;

        await this.mixDescargarArchivo(fileData, 'proyectoDocumentos');
      }
    },
  },
};
</script>

<style lang="scss">

</style>
